export default __webpack_public_path__ + "static/media/4-NetworkConnections.6dcb912f.jpeg";